import { RequestCancelledError } from 'copyright-clearance-center-common-ui-react';

export async function safeExecuteAsync<TResult>(
	action: () => Promise<TResult>,
	defaultValue: TResult,
	showError: (message: string, title?: string) => void
): Promise<TResult> {
	try {
		return await action();
	} catch (err) {
		if (err instanceof RequestCancelledError) {
			return defaultValue;
		}

		if (err instanceof Error) {
			showError(err.message);
		}
	}

	return defaultValue;
}

export function safeExecute<TResult>(
	action: () => TResult,
	defaultValue: TResult,
	showError: (message: string, title?: string) => void
): TResult {
	try {
		return action();
	} catch (err) {
		if (err instanceof RequestCancelledError) {
			return defaultValue;
		}

		if (err instanceof Error) {
			showError(err.message);
		}
	}

	return defaultValue;
}
